
/// <reference path='../_all.ts' />

module shoppinglist {
  'use strict';

  export class AvailabilityData {
    constructor(
      public Status: number,
      public QtyAvailable: number,
      public UnitDe: string,
      public UnitEn: string,
      public TimeToShipPeriod: number,
      public TimeToShip: number,
      public TextDe: string,
      public TextEn: string)
    {
    }
  }
}